import React from "react";
import Landing from "./Landing";

function App() {
  return <Landing />;
}

export default App;
